import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enUS from './en-us'

/**
 * Port of the vue-i18n setup in boot/i18n.js. The original catalogue held two
 * placeholder strings; the scaffolding is kept so the UI copy has somewhere to
 * move to, rather than being deleted and needing to be rebuilt later.
 */
export const resources = {
  'en-us': { translation: enUS },
} as const

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en-us',
  fallbackLng: 'en-us',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
